module.exports = __webpack_public_path__ + "/bundle/asset/admission6-4133b7d12d8a65677259072ed5a0646f.png";